import { render, staticRenderFns } from "./VaimoHeading.vue?vue&type=template&id=636d231d&scoped=true&"
import script from "./VaimoHeading.vue?vue&type=script&lang=js&"
export * from "./VaimoHeading.vue?vue&type=script&lang=js&"
import style0 from "./VaimoHeading.vue?vue&type=style&index=0&id=636d231d&prod&lang=scss&scoped=true&"
import style1 from "./VaimoHeading.vue?vue&type=style&index=1&id=636d231d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d231d",
  null
  
)

export default component.exports